import { DefaultButton } from "../../../../components/form";
import FlexBox from "../../../../components/layouts/Flexbox";
import { ExpiredTimesToggleProps } from "./types";

export function ExpiredTimesToggle({
  showExpiredTimes,
  onToggle,
}: ExpiredTimesToggleProps) {
  return (
    <FlexBox justifyContent="center">
      <DefaultButton variant="text" color="secondary" size="small" onClick={onToggle}>
        {showExpiredTimes ? "Hide expired times" : "View expired times"}
      </DefaultButton>
    </FlexBox>
  );
}
